import React from "react";
import { lazyWithRetry } from "utils/lazy-with-retry";

const LazyAgentWork = lazyWithRetry(() => import("./AgentWork"));

const AgentWork = (
  props: JSX.IntrinsicAttributes & { children?: React.ReactNode },
) => <LazyAgentWork {...props} />;

export default AgentWork;
